module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct-1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_vm._v(" CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword#for1",
      "id": "fo1"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgments#acks1",
      "id": "ack1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction#intr1",
      "id": "int1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#ch-1",
      "id": "toc-1"
    }
  }, [_vm._v("Chapter 1:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("The Dark Side")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#ch-2",
      "id": "toc-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("Purpose in Pain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#ch-3",
      "id": "toc-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("Tear Down These Walls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#ch-4",
      "id": "toc-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("Reinforced Walls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#ch-5",
      "id": "toc-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("Scarlet Letter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#ch-6",
      "id": "toc-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("Potter’s Field")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#ch-7",
      "id": "toc-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("Snake Bitten")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ch-8",
      "id": "toc-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("Collateral Damage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ch-9",
      "id": "toc-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:"), _c('span', {
    staticClass: "spa"
  }, [_vm._v("The Judas Goat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch-10",
      "id": "toc-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Orphan Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch-11",
      "id": "toc-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Journey to Wholeness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ch-12",
      "id": "toc-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Right as Rain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/notes#notes1",
      "id": "not1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/about_the_author#abs1",
      "id": "ab1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/contect_the_author#sus1",
      "id": "cu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contact the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f01114b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0